import { project, projects, projectUpdate, projectPost } from "../../api";

export default {
	state: {
		all: [],
		single: {},
		page: 1
	},

	actions: {
		fetchProjects(
			context,
			{
				all,
				paginate,
				done = false,
				page = 1,
				limit = 30,
				search = null,
				members = []
			}
		) {
			let token = context.getters.getToken;

			return projects({
				token,
				all,
				page,
				paginate,
				done,
				limit,
				search,
				members
			})
				.then(response =>
					context.commit("setProjectsList", response.data)
				)
				.catch(e => console.log(e));
		},

		fetchSingleProject(context, id) {
			let token = context.getters.getToken;
			return project({ token, id })
				.then(response =>
					context.commit("setSingleProject", response.data)
				)
				.catch(e => console.log(e));
		},

		projectUpdate(context, { id, data }) {
			let token = context.getters.getToken;
			return projectUpdate({ token, id, data })
				.then(response =>
					context.commit("setSingleProject", response.data)
				)
				.catch(e => console.log(e));
		},

		postProject(context, data) {
			let token = context.getters.getToken;
			return projectPost({ token, data }).catch(e => console.log(e));
		}
	},

	mutations: {
		setProjectsList(state, payload) {
			console.log("setProjectsList payload", payload);
			state.all = payload;
		},

		setProjectsPage(state, payload) {
			console.log("setProjectsPage payload", payload);
			state.page = parseInt(payload);
		},

		setSingleProject(state, payload) {
			console.log("setSingleProject payload", payload);
			state.single = payload;
		},

		clearSingleProject(state) {
			state.single = {};
		}
	},

	getters: {
		hasProjects(state) {
			return Object.keys(state.all).length > 0;
		},

		getProjectsPage(state) {
			return state.page;
		},

		hasSingleProject(state) {
			return Object.keys(state.single).length > 0;
		}
	}
};
